import { Injectable } from '@angular/core';
import { VideoBanner } from './video-banner.model';
import { CmsService, OccConfig } from '@spartacus/core';
import { combineLatest, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VideoBannerService {
  constructor(
    private cmsService: CmsService,
    private occConfig: OccConfig,
  ) {}

  normalize(data: any): Observable<VideoBanner[]> {
    const banners$: Observable<VideoBanner>[] =
      (data.banners || ``).split(` `)?.map((bannerID: string) => this.cmsService.getComponentData(bannerID)) || [];

    return combineLatest(banners$).pipe(
      map((dirtVideoBanners: any[]) => {
        let videoBanners: VideoBanner[] = [];

        videoBanners = dirtVideoBanners.map((banner: any) => {
          const videoBanner: VideoBanner = {
            title: banner?.title,
            banner: {
              src: this.occConfig.backend?.occ?.baseUrl + banner?.image?.url,
            },
            text: {
              line1: undefined,
              line2: undefined,
            },
          };

          if (banner?.video?.url) {
            videoBanner.video = {
              src: this.occConfig.backend?.occ?.baseUrl + banner?.video?.url,
            };
          }

          if (banner?.action?.linkName && banner?.action?.url) {
            videoBanner.action = {
              label: banner.action.linkName,
              url: banner.action.url,
              isExternal: banner.action.target === `true`,
            };
          }

          if (banner?.line1) {
            videoBanner.text!.line1 = banner?.line1;
          }

          if (banner?.line2) {
            videoBanner.text!.line2 = banner?.line2;
          }

          return videoBanner;
        });

        return videoBanners;
      }),
    );
  }
}
